import AppShortcutRoundedIcon from '@mui/icons-material/AppShortcutRounded';
import DevicesOtherTwoToneIcon from '@mui/icons-material/DevicesOtherTwoTone';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import { Avatar, Grid, IconButton, Paper, Stack, Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import GetAvatarInitials from 'functions/GetAvatarInitials';
import getInitials from 'functions/GetInitials';
import GetPriorityColor from 'functions/GetPriorityColor';
import {
  EnumCompanyProductStatus,
  MissingPhoto,
} from 'Interfaces/IGlobalTypeConfig';
import { useNavigate } from 'react-router';
import CustomAvatar from '../customAvatar';
import { getStatusText } from 'functions/GetStatusText';
function getFormattedTimeDifference(date1: Date, date2: Date): string {
  const diffInMilliseconds: number = Math.abs(
    date2.getTime() - date1.getTime()
  ); // Absolutt forskjell i millisekunder

  // Konverter til dager
  const diffInDays: number = diffInMilliseconds / (1000 * 60 * 60 * 24);

  // Hvis differansen er over 1 dag
  if (diffInDays >= 1) {
    const formattedDays: string = diffInDays.toFixed(1); // Formater til én desimal
    return `D: ${formattedDays}`;
  }

  // Hvis differansen er under 1 dag, formater som timer og minutter
  const diffInMinutes: number = Math.floor(diffInMilliseconds / 1000 / 60);
  const hours: number = Math.floor(diffInMinutes / 60);
  const minutes: number = diffInMinutes % 60;

  const formattedHours: string = String(hours).padStart(2, '0');
  const formattedMinutes: string = String(minutes).padStart(2, '0');

  return `H: ${formattedHours}:${formattedMinutes}`;
}

function getColorBasedOnDifference(
  date1: Date,
  date2: Date,
  days: number
): string {
  const diffInMilliseconds: number = Math.abs(
    date2.getTime() - date1.getTime()
  );
  const diffInDays: number = diffInMilliseconds / (1000 * 60 * 60 * 24);

  if (diffInDays >= days * 3) {
    return 'secondary.light'; // Bruk denne fargen
  } else if (diffInDays >= days) {
    return 'secondary.text'; // Bruk denne fargen
  }
  return 'default.main'; // Standardfarge
}

export const SingleTicketView = (props: any) => {
  let navigate = useNavigate();
  if (!props.ticket) {
    return null; // You can return a placeholder or null here
  }
  console.log(
    'props.ticket',
    props.ticket ? props.ticket : 'No companyProduct',
    props
  );
  const id = `${props.ticket.id}`;
  const index = props.index;
  const ticket = props?.ticket;

  const handleMouseEnter = () => {
    if (props.setIsDragDisabled) {
      props.setIsDragDisabled(true);
    }
  };

  const handleMouseLeave = () => {
    if (props.setIsDragDisabled) {
      props.setIsDragDisabled(false);
    }
  };

  // calculating date difference
  const date1 = new Date(ticket.created) as Date;
  const date2 = new Date() as Date;
  const date3 = new Date(ticket.updated) as Date;
  // console.log('date1', date1);
  // console.log('date2', date2);
  // console.log('ticket', ticket);

  const formattedTimeDifference: string = getFormattedTimeDifference(
    date1,
    date2
  );
  const formatLastUpdated: string = getFormattedTimeDifference(date3, date2);

  if (!ticket) {
    return (
      <Paper
        // ref={setNodeRef}
        variant='elevation3'
        sx={{
          mb: 1,
          borderLeft: 8,
          borderRight: 1,
          borderColor: GetPriorityColor(ticket.priority),
        }}
        // style={draggableStyle}
      >
        <Stack direction={'row'}>
          <Grid container direction={'row'}></Grid>
        </Stack>
      </Paper>
    );
  }
  const companyProductColor = (product: any) => {
    const status = product.status;

    switch (status) {
      case EnumCompanyProductStatus.NONE:
      case EnumCompanyProductStatus.DELIVERED:
      case EnumCompanyProductStatus.PRODUCT_RECEIVED:
        return 'rgba(0, 255, 174, 0.5)';

      case EnumCompanyProductStatus.STORAGE:
      case EnumCompanyProductStatus.SERVICE:
      case EnumCompanyProductStatus.PROCESSING:
      case EnumCompanyProductStatus.TO_DELETE:
        return 'rgba(255, 0, 0, 0.5)';

      case EnumCompanyProductStatus.AWAITING_TO_BE_ORDERED:
        return 'rgba(255, 166, 0, 0.5)';

      case EnumCompanyProductStatus.PRODUCT_ORDERED:
        return 'rgba(255, 166, 0, 0.5)';

      case EnumCompanyProductStatus.PRODUCT_IN_TRANSIT:
        return 'rgba(255, 166, 0, 0.5)';

      default:
        return '#9e9e9e'; // Grey - unknown/default
    }
  };

  let direction = ticket?.ticketPosts[0]?.direction ?? 1;

  console.log('ticket.company?.url', ticket.company?.url);

  return (
    <Paper
      // ref={setNodeRef}
      variant='elevation3'
      // onMouseEnter={handleMouseEnter}
      //  onMouseLeave={handleMouseLeave}
      onClick={(event: any) => {
        event.stopPropagation();
        if (props.onClick) {
          props.onClick();
        } else {
          navigate(`/tickets/${ticket.id}/communications`);
        }
        //console.log('event.stopPropagation', event);
      }}
      sx={{
        p: 0,
        mb: 1,
        border: 0.5,
        borderLeft: 8,
        borderRight: 3,
        borderColor: GetPriorityColor(ticket.priority),
        borderBottomColor: 'primary.light',
        borderTopColor: 'primary.light',
        backgroundColor:
          direction === 2 ? 'rgba(0, 255, 100, 0.1)' : 'primary.main',
        ':hover': {
          cursor: 'pointer',
          filter: 'brightness(120%)',
          transition: 'all 0.2s ease-in-out',
        },
      }}
    >
      <Stack direction={'row'} sx={{ p: 0, m: 0 }}>
        <Typography
          sx={{
            pl: 1,
            pr: 2,
            m: 0,
            display: 'flex',
            flexGrow: 1,
            textAlign: 'left',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignSelf: 'flex-start',
            //alignContent: 'center',
            //justifyContent: 'center',
            alignItems: 'center',
            height: 32,
            whiteSpace: 'nowrap',
            fontWeight: 'Bold',
            fontSize: 14,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
          }}
        >
          {ticket.title}
        </Typography>
        <Grid sx={{}}>
          {/* ICON ID THERE IS PRODUCT CONTECTED TO TICKET */}

          {ticket.ticketProducts &&
            ticket.ticketProducts.map((product: any, index: number) => {
              console.log(`ticketProducts: ${index + 1}`, {
                product,
              });

              return (
                <Tooltip
                  title={`${product.product.name} - Qty: ${
                    product.quantity
                  } - Status: ${getStatusText(product.status)}`}
                  arrow
                  placement='top'
                >
                  <IconButton
                    key={index}
                    sx={{
                      p: 0,
                      mr: 0.5,
                      color: companyProductColor(product),
                    }}
                  >
                    <DevicesOtherTwoToneIcon sx={{ mt: -1, fontSize: 24 }} />
                  </IconButton>
                </Tooltip>
              );
            })}
        </Grid>
        <Grid sx={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
          <Typography
            sx={{
              display: 'flex',
              textAlign: 'left',
              alignSelf: 'flex-start',
              alignItems: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontWeight: 'normal',
              fontSize: 14,
              height: 32,
              pl: 2,
              pr: 2,
              m: 0,
            }}
          >
            {ticket.ticketNo}
          </Typography>
        </Grid>
        <Grid
          sx={{
            pr: 1,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderTopRightRadius: 5,
          }}
        >
          {ticket.isApp ? (
            <IconButton
              key={index}
              sx={{
                p: 0,
                mr: 0.5,
                pt: 0.5,
                color: GetPriorityColor(ticket.priority),
              }}
            >
              <AppShortcutRoundedIcon sx={{ mt: -1, fontSize: 20 }} />
            </IconButton>
          ) : (
            <IconButton
              key={index}
              sx={{
                p: 0,
                mr: 0.5,
                color: GetPriorityColor(ticket.priority),
              }}
            >
              <MailOutlineRoundedIcon sx={{ mt: -1, fontSize: 20 }} />
            </IconButton>
          )}
        </Grid>
      </Stack>
      <Stack direction={'row'}>
        <Grid container direction={'row'} sx={{ pl: 1 }}>
          <Grid item sx={{ width: 65 }}>
            <Stack direction={'column'}>
              <Typography
                sx={{
                  m: 0,
                  p: 0,
                  textAlign: 'left',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: 'bold',
                  fontSize: 10,
                  color: getColorBasedOnDifference(date3, date2, 3),
                }}
              >
                Updated
              </Typography>
              <Typography
                sx={{
                  m: 0,
                  p: 0,
                  textAlign: 'left',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: 'bold',
                  fontSize: 12,
                  color: getColorBasedOnDifference(date3, date2, 3),
                }}
              >
                {formatLastUpdated}
              </Typography>
              <Typography
                sx={{
                  mt: 0.2,
                  p: 0,
                  textAlign: 'left',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: 'bold',
                  fontSize: 10,
                  // color: getColorBasedOnDifference(date1, date2, 3),
                }}
              >
                created
              </Typography>
              <Typography
                sx={{
                  m: 0,
                  p: 0,
                  textAlign: 'left',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: 'bold',
                  fontSize: 12,
                  // color: getColorBasedOnDifference(date1, date2, 3),
                }}
              >
                {formattedTimeDifference}
              </Typography>
            </Stack>
          </Grid>
          <Grid item sx={{ mr: 1.5, width: 120, height: 70 }}>
            <Paper
              sx={{
                display: 'flex',
                height: 70,
                alignSelf: 'flex-center',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                backgroundColor: 'primary.main',
              }}
            >
              {ticket.company?.url && ticket.company.url !== '' ? (
                <Tooltip title={ticket.company?.name}>
                  <img
                    src={ticket.company?.url || MissingPhoto.COMPANY_URL}
                    style={{
                      padding: 0,
                      width: 120,
                      height: 60,
                      borderRadius: 3,
                      objectFit: 'scale-down',
                    }}
                    alt={'previewUrl'}
                  />
                </Tooltip>
              ) : (
                <Tooltip title={ticket.company?.name}>
                  <CustomAvatar avatarName={ticket.company?.name || ''} />
                </Tooltip>
              )}
            </Paper>
          </Grid>
          <Grid
            item
            sx={{
              pr: 1,
              display: 'flex',
              height: 70,
              alignSelf: 'flex-center',
              justifyContent: 'center',
              alignItems: 'center',
              alignContent: 'center',
              backgroundColor: 'primary.main',
            }}
          >
            <Tooltip title={ticket.contact?.name}>
              {ticket.contact?.url ? (
                <img
                  src={ticket.contact?.url || MissingPhoto.EMPLOYEE_URL}
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: 50,
                    objectFit: 'scale-down',
                    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
                  }}
                  alt={'previewUrl'}
                />
              ) : (
                <Avatar
                  {...GetAvatarInitials(ticket.contact.name, 60, 60, 10)}
                />
              )}
            </Tooltip>
          </Grid>

          <Grid item xs zeroMinWidth sx={{ mr: 1, flexGrow: 1 }}>
            <Typography
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '3',
                WebkitBoxOrient: 'vertical',
                textAlign: 'left',
                whiteSpace: 'wrap',
                fontWeight: 'normal',
                fontSize: 14,
              }}
            >
              {ticket?.ticketPosts[0]?.message ?? ''}
            </Typography>
          </Grid>

          {!ticket.responsible ? null : (
            <Grid
              item
              sx={{
                pr: 1,
                display: 'flex',
                height: 70,
                alignSelf: 'flex-center',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                backgroundColor: 'primary.main',
              }}
            >
              <Tooltip title={ticket.responsible?.name}>
                {ticket.responsible?.url ? (
                  <img
                    src={ticket.responsible?.url || MissingPhoto.EMPLOYEE_URL}
                    style={{
                      width: 60,
                      height: 60,
                      borderRadius: 50,
                      objectFit: 'scale-down',
                      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
                    }}
                    alt={'previewUrl'}
                  />
                ) : (
                  <Avatar
                    {...GetAvatarInitials(ticket.responsible.name, 60, 60, 10)}
                  />
                )}
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Stack>
    </Paper>
  );
};
